const userAccountValidator = props => {
    // Destructured props
    const {formValues, isBrazilian} = props;

    // The regexes for the value to be validated from
    const emailRegex = new RegExp("^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$");
    const dobRegex = /([0-2][0-9]|3[0-1])\/(0[0-9]|1[0-2])\/[0-9]{4}/;
    const taxVatRegex = new RegExp("^\\d{3}\\.\\d{3}\\.\\d{3}\\-\\d{2}$");

    // Actual form field validator for the first step
    const validateForm = props => {
        // Destructured props
        const {
            target,
            value
        } = props;

        let errors = {};

        // Validates each field
        switch (target) {
            case "fullName":
                if (!value) {
                    errors.fullName = "Esse campo é obrigatório.";
                } else if (value && value.length < 5) {
                    errors.fullName = "Seu nome deve possuir no mínimo 5 caracteres.";
                } else {
                    errors.fullName = "";
                }

                break;
            case "email":
                if (!value) {
                    errors.email = "Esse campo é obrigatório.";
                } else if (value && !emailRegex.test(value)) {
                    errors.email = "Insira um endereço de email válido.";
                } else if (value.endsWith(".co")) {
                    errors.email = "Insira um endereço de email válido.";
                } else {
                    errors.email = "";
                }

                break;
            case "phoneNumber":
                if (!value) {
                    errors.phoneNumber = "Esse campo é obrigatório.";
                } else {
                    errors.phoneNumber = "";
                }

                break;
            case "affiliation":
                if (!value) {
                    errors.affiliation = "Esse campo é obrigatório.";
                } else if (value && value.length < 5) {
                    errors.affiliation = "O nome deve possuir no mínimo 5 caracteres.";
                } else {
                    errors.affiliation = "";
                }

                break;
            case "dob":
                if (!value) {
                    errors.dob = "Esse campo é obrigatório.";
                } else if (value && !dobRegex.test(value)) {
                    errors.dob = "Insira uma data de nascimento válida.";
                } else {
                    errors.dob = "";
                }

                break;
            case "taxvat":
                if(isBrazilian) {
                    if (!value) {
                        errors.taxvat = "Esse campo é obrigatório.";
                    } else if (value && !taxVatRegex.test(value)) {
                        errors.taxvat = "Insira um número de CPF válido.";
                    } else {
                        errors.taxvat = "";
                    }
                } else {
                    errors.taxvat = "";
                }

                break;
            case "passport":
                if(!isBrazilian) {
                    if (!value) {
                        errors.taxvat = "Esse campo é obrigatório.";
                    }else {
                        errors.taxvat = "";
                    }
                } else {
                    errors.taxvat = "";
                }

                break;
            case "gender":
                if (!value) {
                    errors.gender = "Esse campo é obrigatório.";
                } else {
                    errors.gender = "";
                }

                break;
            default:
                return errors;
        }

        return errors;
    }

    // Method to perform a validation in all fields at once
    const validateAll = () => {
        let errors = {};

        // Iterates through each field validating them
        Object.keys(formValues).forEach(key => {
            const args = {
                target: key,
                value: formValues[key]
            }

            errors = {
                ...errors,
                ...validateForm(args)
            }
        })

        // Returns the errors object to be set into the errors state
        return errors;
    }

    return {
        validateForm,
        validateAll
    }
}

export default userAccountValidator;
